import React, { useState } from "react"
import { Link } from "react-router-dom"
import data from "../../data/db.json"

export default function HomeCards() {
  const [cards] = useState(data.accessories)

  return (
    <>
      <section className="max-width">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 py-10 xl:py-20">
          {cards.map(({ id, name, desc, features, price, images }) => (
            <Link
              to={`/accessories/${name}`}
              key={id}
              className="bg-slate-100 hover:bg-slate-200 transition-all duration-150 rounded-lg shadow-md"
            >
              <img
                src={images[0]}
                alt={name}
                className="md:h-72 md:object-cover md:w-full rounded-t-lg"
              />

              <article className="p-5">
                <div>
                  <h5>{name}</h5>
                  <h6>{price}</h6>
                </div>
                <p className="text-sm mt-3">{desc}</p>
              </article>
            </Link>
          ))}
        </div>
      </section>
    </>
  )
}
